// extracted by mini-css-extract-plugin
export default {"container":"Founder_container__-NTXv","text":"Founder_text__VCTep","image":"Founder_image__MwZv4"};